import { apiClient, requiresAuth } from '../client';
import { Walk } from '../../types';

export const walksService = {
  getAllWalks: async () => {
    console.log('[API] walksService.getAllWalks - Fetching all walks - START');
    try {
      return requiresAuth(async () => {
        const response = await apiClient.get('/walks');
        console.log(
          '[API] walksService.getAllWalks - Response data type:',
          typeof response.data
        );
        console.log(
          '[API] walksService.getAllWalks - Is response.data an array?',
          Array.isArray(response.data)
        );
        if (!Array.isArray(response.data)) {
          console.log(
            '[API] walksService.getAllWalks - Response data structure:',
            response.data
          );
        }
        return response.data.walks || response.data;
      });
    } catch (error) {
      console.error(
        '[API] walksService.getAllWalks - Error fetching walks:',
        error
      );
      throw error;
    }
  },

  getWalkById: async (walkId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/walks/${walkId}`);
      return response.data;
    });
  },

  createWalk: async (walkData: Partial<Walk>) => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/walks', walkData);
      return response.data;
    });
  },

  updateWalk: async (walkId: string, walkData: Partial<Walk>) => {
    return requiresAuth(async () => {
      const response = await apiClient.put(`/walks/${walkId}`, walkData);
      return response.data;
    });
  },

  deleteWalk: async (walkId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.delete(`/walks/${walkId}`);
      return response.data;
    });
  },

  getOpenWalks: async () => {
    return requiresAuth(async () => {
      const response = await apiClient.get('/walks/open');
      return response.data;
    });
  },

  getWalksByOwner: async (ownerId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/walks/owner/${ownerId}`);
      return response.data;
    });
  },

  getWalkDetail: async (walkId: string) => {
    return requiresAuth(async () => {
      const response = await apiClient.get(`/walks/${walkId}`);
      return response.data;
    });
  },
};
